import { useModals } from "web/hooks/modals"
import UnitSettings from "./UnitSettings"

export default function useUnitsSettingModal({
  handleUpdateUnits,
  currencyCode,
  areaUnitCode,
  lengthUnitCode,
  distanceUnitCode,
}) {
  const { showModal } = useModals()

  return async function () {
    return await showModal({
      title: "Currency and Units",
      fullScreen: false,
      heightPixels: 650,
      widthPixels: 400,
      component: ({ close }) => (
        <UnitSettings
          close={close}
          handleUpdateUnits={handleUpdateUnits}
          currencyCode={currencyCode}
          areaUnitCode={areaUnitCode}
          lengthUnitCode={lengthUnitCode}
          distanceUnitCode={distanceUnitCode}
        />
      ),
    })
  }
}
